<template>
    <b-modal v-model="show" title="АМОРТИЗАЦИЯ ПАРАМЕТРИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingDepreciationFieldEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingDepreciationFieldEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingDepreciationFieldEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Сортировка</label>
                        <numeric-input v-model="data.sortOrder" :precision="0"></numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_DEPRECIATION_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: "CadastreBuildingDepreciationFieldEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: {
                    code: '',
                    name: '',
                    nameRu: '',
                    sortOrder: null
                }
            }
        },
        validations:{
            data:{
                code:{
                    required
                },
                name:{
                    required
                },
                nameRu: {
                    required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid){
                    return;
                }
                const vm = this;
                this.processing = true;
                this.$http.post('cadastre/building/depreciation/field', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreBuildingDepreciationFieldChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showCadastreBuildingDepreciationFieldEditModal', (data) => {
                if (data) {
                    this.data = clone(data);
                } else {
                    this.data = {
                        code: '',
                        name: '',
                        nameRu: '',
                        sortOrder: null
                    };
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
